import { render, staticRenderFns } from "./ValesCaja.vue?vue&type=template&id=0215cec4&"
import script from "./ValesCaja.vue?vue&type=script&lang=js&"
export * from "./ValesCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports